import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { TaskExtensionExclusionRequestDto, TemplatesByTypeDto } from '../../../interfaces/TaskExtentionDtos/taskExtention.model';
import { createTaskExclusionAsync, GetTemplatesByTypeAsync } from '../../../services/TaskExterntionService/TaskExterntionService';
import { useAuth } from '../../../firebase/AuthProvider';
import { toast } from 'react-toastify';
import { TaskType } from '../../../Data/SD';

interface AddTaskExlusionModalProps {
    showAddExclusionModal: boolean,
    handleCloseAddExclusionModal: () => void;
    refreshList? : () => void;
}

const AddTaskExlusionModal: React.FC<AddTaskExlusionModalProps> = ({
    handleCloseAddExclusionModal,
    showAddExclusionModal,
    refreshList
}) => {
    const { currentUser } = useAuth();
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [taskTemplates, setTaskTemplates] = useState<TemplatesByTypeDto[]>([]);
    const [selectedType, setSelectedType] = useState<string>(TaskType.Interim);
    const [selectedTemplateId, setSelectedTemplateId] = useState<number>();

    useEffect(() => {
        if (selectedType) {
            GetTemplatesByType(selectedType);
        }
    }, [selectedType]);

    const handleSaveExlusion = async () => {
        if (!selectedTemplateId) {
            toast.error("Please select a task template.");
            return;
        }

        const payload: TaskExtensionExclusionRequestDto = {
            templateTaskTypeId: null,
            templateInterimTaskTypeId: null,
            isActive: true
        }
        if (selectedType === TaskType.Interim) {
            payload.templateInterimTaskTypeId = selectedTemplateId;
        } else {
            payload.templateTaskTypeId = selectedTemplateId;
        }

        const token = await currentUser?.getIdToken();
        if (!token) return;
        setIsSaving(true);
        createTaskExclusionAsync(token, payload)
            .then((res) => {
                if (res.success) {
                    toast.success(res.message);
                    refreshList?.();
                    handleCloseAddExclusionModal();
                } else {
                    toast.error(res.message);
                }
            })
            .catch((err) => {
                toast.error(err.message || "Something went wrong!");
            })
            .finally(() => {
                setIsSaving(false);
            });
    }



    const GetTemplatesByType = async (type: string) => {
        const token = await currentUser?.getIdToken();
        if (!token) return;

        setTaskTemplates([]);
        setSelectedTemplateId(undefined);
        setIsLoading(true);
        GetTemplatesByTypeAsync(token, type).then((res) => {
            if (res.success) {
                setTaskTemplates(res.data);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message || "Something went wrong!");
        }).finally(()=> setIsLoading(false))
    }
    return (
        <>
            <Modal show={showAddExclusionModal} onHide={handleCloseAddExclusionModal} className='custom_popup' centered backdrop="static"   // <- prevents closing on outside click
                keyboard={false} >
                <Modal.Header closeButton>
                    <Modal.Title>Add Task Exclusion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group controlId="task" className="custom_input_flled mb-3">
                        <Form.Label>Select Task Type</Form.Label>
                        <Form.Select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
                            <option value={TaskType.Interim}>{TaskType.Interim}</option>
                            <option value={TaskType.Recurring}>{TaskType.Recurring}</option>
                        </Form.Select>

                    </Form.Group>
                    <Form.Group controlId="tasktype" className="custom_input_flled mb-0">
                        <Form.Label>Select Task Template</Form.Label>
                        <Form.Select value={selectedTemplateId} onChange={(e) => setSelectedTemplateId(Number(e.target.value))}>
                            <option value="">Select Task Template</option>
                            {isLoading ?
                                <option value="" disabled>Loading...</option>
                                : (
                                    <>
                                        {taskTemplates.map((item) => (
                                            <option key={item.templateTaskId} value={item.templateTaskId}>{item.title}</option>
                                        ))}
                                    </>
                                )
                            }

                        </Form.Select>
                    </Form.Group>



                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseAddExclusionModal}>Close</Button>
                    <Button variant="primary" onClick={handleSaveExlusion} disabled={isSaving} >
                        {isSaving ? "Saving..." : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default AddTaskExlusionModal